import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio T-Shirts" mdxType="Seo" />
    <h1 {...{
      "id": "t-shirt-fundraiser"
    }}>{`T-Shirt Fundraiser`}</h1>
    <p>{`This year we are using our t-shirt sale fundraiser to support our efforts
to reduce the cost of attending the conference for speakers at future
PyOhio events.
All of the proceeds from t-shirt sales this year will go toward those
costs for the next in-person PyOhio event (planned for 2022.)`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.customink.com/fundraising/pyohio-2021",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "716px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.05555555555556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMGBf/EABYBAQEBAAAAAAAAAAAAAAAAAAMAAv/aAAwDAQACEAMQAAABrVb7V2oqAr//xAAcEAACAgIDAAAAAAAAAAAAAAACBQMEAAEGExT/2gAIAQEAAQUCRCGsVQ9anjcB+FOtrxDRW1wUIKkUFD//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAZEQEAAgMAAAAAAAAAAAAAAAABAAISIjH/2gAIAQIBAT8BdXA5LgWQn//EACQQAAIABQMEAwAAAAAAAAAAAAECAAMREiIEBSETFSUxMlLx/9oACAEBAAY/AtxPc1mVkNkC+Ir8uY3XyalaJkC+H7EyzWLOXqn7Y+uOY11qUukkHIxr0CYuBXIxai0F5Pusf//EABwQAAIDAQEBAQAAAAAAAAAAAAERACExQYFhcf/aAAgBAQABPyFJFHDedk4+RvJsx7HbD8QXByQUpQj++xv9rEonLNQ19SJI1luOe1Rk/wBJn//aAAwDAQACAAMAAAAQ58//xAAXEQADAQAAAAAAAAAAAAAAAAAAASEx/9oACAEDAQE/EJEYf//EABcRAQEBAQAAAAAAAAAAAAAAABEBUQD/2gAIAQIBAT8QuVZju5yIkvf/xAAbEAEBAQEBAQEBAAAAAAAAAAABESEAMVFBkf/aAAgBAQABPxBl2rJorRvg61zbyxK/Y0/dME9SZ1i9AeElmzlt9RbsUUi/JxraKYjFNJ+ROoiEDRJVQv8Ae//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/2021/static/7f8b760187f235135d42929d7a516c43/e1989/pyohio-2021-shirts.webp 360w", "/2021/static/7f8b760187f235135d42929d7a516c43/25e9b/pyohio-2021-shirts.webp 716w"],
              "sizes": "(max-width: 716px) 100vw, 716px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/2021/static/7f8b760187f235135d42929d7a516c43/1ff7f/pyohio-2021-shirts.jpg 360w", "/2021/static/7f8b760187f235135d42929d7a516c43/77b0b/pyohio-2021-shirts.jpg 716w"],
              "sizes": "(max-width: 716px) 100vw, 716px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/2021/static/7f8b760187f235135d42929d7a516c43/77b0b/pyohio-2021-shirts.jpg",
              "alt": "PyOhio 2021 Shirts",
              "title": "PyOhio 2021 Shirts",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Shirts available for sale through Aug 1.
They will ship directly to you about two weeks after the sale closes.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.customink.com/fundraising/pyohio-2021",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`Order your t-shirt here now!`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      